














import { Component, Prop, Vue } from 'vue-property-decorator'
import { UserState } from '@/models'

@Component
export default class LoginForm extends Vue {
  protected email: string = ''
  protected password: string = ''

  authenticateUser() {
    const { email, password } = this
    UserState.LOGIN({ email, password })
  }
}
